<template>
  <div
    class="bottom-sheet elevation-12"
    :class="{ 'bottom-sheet--hide': !isShow }"
  >
    <div class="bottom-sheet-header white">
      <v-subheader>
        {{ title }}
      </v-subheader>
      <v-spacer />
      <v-btn
        icon
        class="mt-1 mr-3"
        @click="isShow = !isShow"
      >
        <v-icon v-if="!isShow">
          {{ mdiChevronUp }}
        </v-icon>
        <v-icon v-if="isShow">
          {{ mdiChevronDown }}
        </v-icon>
      </v-btn>
    </div>
    <div class="bottom-sheet-content">
      <slot />
    </div>
  </div>
</template>

<script>
import { mdiChevronUp, mdiChevronDown } from '@mdi/js'

export default {
  props: {
    title: {
      type: String,
      default: null
    }
  },
  data: () => {
    return {
      mdiChevronUp: mdiChevronUp,
      mdiChevronDown: mdiChevronDown,
      isShow: false
    }
  }
}
</script>
